
import { useState } from "react";
import { Typography, Card, Grid, Box } from "@mui/material";
import HeaderGestorConfigs from "../../utils/headerGestorConfigs";
import EstabelecimentoEdit from "../dadosGenericos/estabelecimentoEdit";
import MessageSuccess from "../../messages/messageSuccess";
import MessageError from "../../messages/messageError";
import ImagemEdit from "../../utils/imagemEdit";
import DateHora from "../../utils/dateHora";
import Delete from "../../utils/delete";
import ChangeDirectorTecnico from "../gestDirectorTecnico/changeDirectorTecnico";
import ReenviarLinkReprovacao from "../departamentos/dlif/licenciamento/reenviarLinkReprovacao";

export default function FichaEstabelecimento(props) {
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setMessageError] = useState('')
    const [editDados, setEditDados] = useState(false)
    const [dadosEstabelecimento, setDadosestabelecimento] = useState(props.estabelecimento)
    const [openEditLogo, setOpenEditLogo] = useState(false);
    const [open, setOpen] = useState(false);
    const [changeDirectorTecnico, setChangeDirectorTecnico] = useState(false);
    const [openReenviarLinkReprovacao, setOpenReenviarLinkReprovacao] = useState(false);
    // console.log(dadosEstabelecimento)


    const renderField = (label, value) => (
        <Grid item xs={12} sm={6}>
            <Box>
                <Typography variant="caption" color="text.secondary">
                    {label}
                </Typography>
                <Typography variant="body1">
                    {value || 'Não informado'}
                </Typography>
            </Box>
        </Grid>
    );

    return (
        <Card style={{ padding: 20 }}>
            {messageSuccess && <MessageSuccess message={messageSuccess} />}
            {messageError && <MessageError message={messageError} />}

            <HeaderGestorConfigs
                menu={props?.menu ?? true}
                configArea={'fichaEstabelecimento'}
                title={editDados ? 'EDITAR DADOS' : props.title ? props.title : 'DADOS DO ESTABELECIMENTO'}
                estabelecimento={dadosEstabelecimento}
                editDados={editDados}
                setEditDados={setEditDados}
                delete={setOpen}
                setChangeDirectorTecnico={setChangeDirectorTecnico}
                setOpenReenviarLinkReprovacao={setOpenReenviarLinkReprovacao}
            />

            <Delete
                open={open}
                setOpen={setOpen}
                url={'/estabelecimento/delete'}
                msg={`Tem certeza que deseja eliminar o Estabelecimento ${dadosEstabelecimento?.nome}`}
                id={dadosEstabelecimento._d}
            />

            <ChangeDirectorTecnico
                estabelecimento={dadosEstabelecimento}
                open={changeDirectorTecnico}
                setOpen={setChangeDirectorTecnico}
            />

            <ReenviarLinkReprovacao
                estabelecimento={dadosEstabelecimento}
                openReenviarEmail={openReenviarLinkReprovacao}
                setOpenReenviarEmail={setOpenReenviarLinkReprovacao}
                setMessageSuccess={setMessageSuccess}
                setMessageError={setMessageError}
            />

            {!editDados ?
                <Grid container>
                    <Grid item marginRight={2}>
                        <ImagemEdit
                            data={dadosEstabelecimento}
                            url={'/estabelecimento/change-logo'}
                            local={'estabelecimentoId'}
                            setOpenEditLogo={setOpenEditLogo}
                            openEditLogo={props?.location === 'site' ? false : openEditLogo}
                        />
                    </Grid>

                    {dadosEstabelecimento.status === 'Não Licenciado' ?
                        <Grid xs item>
                            <Box sx={{ backgroundColor: 'rgba(0, 0, 0, 0.03)', padding: '2rem', borderRadius: '4px', mb: 4 }}>
                                <Grid container spacing={2}>
                                    {renderField('Estado', dadosEstabelecimento.status)}
                                    {renderField('Nome', dadosEstabelecimento.nome)}
                                    {renderField('E-mail', dadosEstabelecimento.email)}
                                    {renderField('Provincia', dadosEstabelecimento.provincia)}
                                    {renderField('Município', dadosEstabelecimento.municipio)}
                                    {renderField('Bairro', dadosEstabelecimento.bairro)}
                                    {renderField('Rua / Avenida', dadosEstabelecimento.rua)}
                                </Grid>
                            </Box>
                        </Grid>
                        :
                        <Grid xs item spacing={2}>
                            <Box sx={{ backgroundColor: 'rgba(0, 0, 0, 0.03)', padding: '2rem', borderRadius: '4px', mb: 4 }}>
                                <Grid container spacing={2}>
                                    {renderField('Estado', dadosEstabelecimento.status)}
                                    {renderField('Nome', dadosEstabelecimento.nome)}
                                    {renderField('E-mail', dadosEstabelecimento.email)}
                                    {renderField('Estabelecimento', dadosEstabelecimento.tipo?.designacao)}
                                    {renderField('Carteira do Arquitecto', dadosEstabelecimento.carteiraArquitecto)}
                                    {renderField('Número de processo', dadosEstabelecimento.numeroProcesso)}
                                    {renderField('Número de entrada', dadosEstabelecimento.numeroEntrada)}
                                    {renderField('Data de entrada', dadosEstabelecimento?.dataEntrada ?? <DateHora date={dadosEstabelecimento?.createdAt} />)}
                                    {renderField('Provincia', dadosEstabelecimento.provincia)}
                                    {renderField('Município', dadosEstabelecimento.municipio)}
                                    {renderField('Bairro', dadosEstabelecimento.bairro)}
                                    {renderField('Rua / Avenida', dadosEstabelecimento.rua)}
                                </Grid>
                            </Box>
                        </Grid>
                    }
                </Grid>
                :
                <EstabelecimentoEdit
                    dadosEstabelecimento={dadosEstabelecimento}
                    setDadosEstabelecimento={setDadosestabelecimento}
                    cancelEditDados={setEditDados}
                    setMessageSuccess={setMessageSuccess}
                    setMessageError={setMessageError}
                />
            }
        </Card>
    )
}